<template>
  <div class="hitwrapper person">
    <div v-if="hit.imageUrl" class="photo">
      <Image
        :imageUrl="hit.imageUrl"
        :smallWidth="140"
        :mediumWidth="140"
        :largeWidth="140"
        :altText="''"
      />
    </div>
    <div class="info">
      <div class="hittitle">
        <a :href="hit.url">
          {{ hit.title }}
          <Icon type="arrow-right"/>
        </a>
      </div>
      <div class="pos-and-org" v-if="hasPos || hasOrg">
        <span v-if="hasPos" v-for="(item, index) in hit.positions">
          {{ capitalizeFirstLetter(item) }}{{ index + 1 < hit.positions.length ? ", " : "" }}
        </span>
        <template v-else-if="hasOrg">
          <span>{{ texts.verksamVid }}: </span>
          <span v-for="(item, index) in hit.organisations">
            {{ item }}{{ index + 1 < hit.organisations.length ? ", " : "" }}
          </span>
        </template>
      </div>
      <div class="email" v-if="hit.emailaddress">
        <span><Icon :type="'mail'"/></span>
        <a :href="'mailto:' + hit.emailaddress"
        :aria-label="texts.klickaForAttSkickaEpost + ' ' + hit.emailaddress">
          {{ hit.emailaddress }}
        </a>
      </div>
      <div class="phone" v-if="hit.phonenumbers && hit.phonenumbers.length">
        <span><Icon :type="'phone'"/></span>
        <span>
          <span v-for="(item, index) in hit.phonenumbers">
            <a :href="'tel:' + item" 
            :aria-label="texts.klickaForAttRinga + ' ' + item">
              {{ item }}
            </a>
            {{ index + 1 < hit.phonenumbers.length ? ", " : "" }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from "../../../image/icon.vue";
import Image from "../../../image/image.vue";
export default {
  name: "PersonalItem",
  props: {
    hit: Object,
    texts: Object,
  },
  components: {
    Icon,
    Image,
  },
  data: function () {
    return {
      hasPos: this.hit.positions && this.hit.positions.length,
      hasOrg: this.hit.organisations && this.hit.organisations.length,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string && string.length 
      ? string.charAt(0).toUpperCase() + string.slice(1)
      : "";
    },
  },
};
</script>
